'use client';

import {coreKeeperAppReady} from '@mail-core/dashboard';
import {useEffect} from 'react';

export default function AppReadyReporter() {
  useEffect(() => {
    coreKeeperAppReady();
  }, []);

  return null;
}
